import styled, { createGlobalStyle } from 'styled-components';

import 'swiper/css';
import 'swiper/css/autoplay';
import Section1 from 'components/biz/section1';
import Section2 from 'components/biz/section2';
import Section3 from 'components/biz/section3';
import Section4 from 'components/biz/section4';
import Section5 from 'components/biz/section5';
import Section6 from 'components/biz/section6';
import Section7 from 'components/biz/section7';
import Section8 from 'components/biz/section8';
import Section9 from 'components/biz/section9';
import Section10 from 'components/biz/section10';
import Section11 from 'components/biz/section11';
import { useCallback, useRef } from 'react';

const BizIntroduce = () => {
  const ref = useRef<HTMLElement | null>(null);
  const onClickButton = useCallback(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);
  return (
    <>
      <GlobalStyles />
      <MainContainer>
        {/* <BizHeader /> */}
        <Section1 onClickButton={onClickButton} />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 onClickButton={onClickButton} />
        <Section8 />
        <Section9 />
        <Section10 />
        <Section11 ref={ref} />
      </MainContainer>
    </>
  );
};

const MainContainer = styled.main``;

export default BizIntroduce;

const GlobalStyles = createGlobalStyle`
	html,
	body {
		padding: 0;
		margin: 0;
		font-size: 10px;
	}

	html {
		min-height: 100%;
	}

	body {
		min-height: 100%;
	}

	* {
		font: inherit;
		font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', sans-serif;
		color: #1d1d1d;
		-webkit-tap-highlight-color: transparent;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;

		&::before,
		&::after {
			-webkit-box-sizing: inherit;
			-moz-box-sizing: inherit;
			box-sizing: inherit;
		}
	}

	article,
	aside,
	details,
	figcaption,
	figure,
	header,
	hgroup,
	menu,
	Nav,
	section {
		display: block;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	button {
		padding: 0;
		background-color: rgba(0, 0, 0, 0);
		outline: none;
		border: 0;
		cursor: pointer;
	}

	dd {
		-webkit-margin-start: 0;
	}

	ul {
		-webkit-padding-start: 0;
		list-style-position: inside;
		margin: 0;
	}

	li,
	ol,
	ul {
		list-style: none;
	}

	a {
		margin: 0;
		padding: 0;
		font-size: 100%;
		text-decoration: none;
		color: inherit;
		background: rgba(0, 0, 0, 0);
		cursor: pointer;
	}

	img {
		max-width: 100%;
	}

	b,
	span {
		font-size: inherit;
		color: inherit;
		font-weight: inherit;
	}

	strong {
		font-size: inherit;
		font-weight: bold;
		color: inherit;
	}

	br {
		line-height: inherit;
	}

	footer {
		padding: 0;
	}

	input,
	textarea {
		font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', sans-serif;
		padding: 0;
		appearance: none;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin: 0;
		font-weight: 400;
	}

	dialog {
		display: block;
		padding: 0;
		border: none;
		background: inherit;
	}

	.preventHighlight {
		-webkit-tap-highlight-color: transparent;
	}

	.noselect {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	p {
		margin: 0;
	}

	i {
		font-style: normal;
	}

	::selection {
		background-color: #000;
		color: #fff;
	}

	html.webview, body.webview {
		height: 100%;
	}

	.emoji {
		letter-spacing: 0;
    margin-right: 0.5rem;
	}
`;
